<template>
    <span>
        {{ formattedValue }}
        <font-awesome-icon 
            v-if="tooltip" 
            icon="question-circle" 
            v-tippy="tooltip" 
            class="ml-1 text-gray-400 cursor-pointer" 
        />
    </span>
</template>

<script>
export default {
    props: {
        debugName: {
            type: String
        },
        value: {
            type: [String, Number, Date],
            default: 0 // Set default value to 0
        },
        tooltip: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            formattedValue: null,
        }
    },

    mounted() {
        this.formatNumber(this.value);
    },

    watch: {
        value(newValue) {
            this.formatNumber(newValue);
        }
    },

    methods: {
        formatNumber(input) {
            if (input == null) { // Handle null or undefined
                input = 0;
            } else {
                // Cast input to a number
                input = Number(input);
            }

            // Turn money number into a formatted string
            this.formattedValue = new Intl.NumberFormat('sv-SE', {
                style: 'currency',
                currency: 'SEK'
            }).format(input);
        }
    }
}
</script>
<style scoped>
span {
    /* background: red; */
}
</style>